// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QwI9","delete":"styles_delete__1iD_J","update":"styles_update__ntjju","add":"styles_add__3Qi5z"};